import React, { useState } from "react";
import { CalendarPlus, ListPlus, BellPlus, MailPlus, Zap } from "lucide-react";
import AppointmentModal from "@/components/calendar/AppointmentModal";
import TaskModal from "@/components/tasks/TaskModal";
import AddReminderModal from "@/components/modals/AddReminderModal";
import CreateRequestModal from "@/components/modals/CreateRequestModal";
import { useEffect } from "react";
import { endpoints } from "@/lib/api";

const actions = [
  { key: "appt", label: "Add Appointment", desc: "Book a meeting", icon: CalendarPlus, tone: "from-blue-500 to-indigo-600", testId: "quick-action-add-appointment" },
  { key: "task", label: "Add Task", desc: "Track a to-do", icon: ListPlus, tone: "from-indigo-500 to-violet-600", testId: "quick-action-add-task" },
  { key: "reminder", label: "Add Reminder", desc: "Never forget", icon: BellPlus, tone: "from-purple-500 to-fuchsia-600", testId: "quick-action-add-reminder" },
  { key: "request", label: "Create Request", desc: "Client intake", icon: MailPlus, tone: "from-sky-500 to-blue-600", testId: "quick-action-create-request" },
];

export default function QuickActions({ onCreated }) {
  const [open, setOpen] = useState(null);
  const [consultants, setConsultants] = useState([]);
  useEffect(() => { endpoints.listConsultants().then(setConsultants).catch(() => {}); }, []);

  return (
    <div data-testid="quick-actions-card" className="glass-card rounded-3xl p-5 sm:p-6 h-full card-hover">
      <div className="flex items-center gap-2 mb-4">
        <div className="h-8 w-8 rounded-lg bg-indigo-50 dark:bg-indigo-500/15 text-indigo-600 dark:text-indigo-300 flex items-center justify-center">
          <Zap className="h-4 w-4" />
        </div>
        <div>
          <h2 className="font-display font-bold text-[15px] tracking-tight">Quick Actions</h2>
          <p className="text-xs text-slate-500">Create in a click</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {actions.map((a) => {
          const Icon = a.icon;
          return (
            <button
              key={a.key}
              data-testid={a.testId}
              onClick={() => setOpen(a.key)}
              className="group text-left rounded-2xl p-4 border border-slate-200/70 dark:border-white/10 bg-white/60 dark:bg-slate-900/40 hover:border-indigo-300/70 dark:hover:border-indigo-400/50 transition-all hover:-translate-y-0.5"
            >
              <div className={`h-9 w-9 rounded-xl bg-gradient-to-br ${a.tone} text-white flex items-center justify-center mb-3 shadow-md shadow-indigo-500/20 group-hover:scale-110 transition-transform`}>
                <Icon className="h-4.5 w-4.5" />
              </div>
              <div className="text-[13px] font-semibold">{a.label}</div>
              <div className="text-[11px] text-slate-500 mt-0.5">{a.desc}</div>
            </button>
          );
        })}
      </div>

      <AppointmentModal
        open={open === "appt"}
        initial={null}
        consultants={consultants}
        onOpenChange={(o) => !o && setOpen(null)}
        onChanged={() => { onCreated?.(); setOpen(null); }}
      />
      <TaskModal
        open={open === "task"}
        initial={null}
        consultants={consultants}
        onOpenChange={(o) => !o && setOpen(null)}
        onChanged={() => { onCreated?.(); setOpen(null); }}
      />
      <AddReminderModal open={open === "reminder"} onOpenChange={(o) => !o && setOpen(null)} onCreated={onCreated} />
      <CreateRequestModal open={open === "request"} onOpenChange={(o) => !o && setOpen(null)} onCreated={onCreated} />
    </div>
  );
}
